import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const HandleIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 15),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M1.5 3A1.5 1.5 0 1 1 3 1.5 1.5 1.5 0 0 1 1.5 3M8.5 3A1.5 1.5 0 1 1 10 1.5 1.5 1.5 0 0 1 8.5 3M1.5 9A1.5 1.5 0 1 1 3 7.5 1.5 1.5 0 0 1 1.5 9M8.5 9A1.5 1.5 0 1 1 10 7.5 1.5 1.5 0 0 1 8.5 9M1.5 15A1.5 1.5 0 1 1 3 13.5 1.5 1.5 0 0 1 1.5 15M8.5 15a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8.5 15"
    })
  });
};

export { HandleIcon };
//# sourceMappingURL=handle.js.map
